import { RemoteListOnlineUsersPerOrganizationIndicators } from 'data/usecases/dashboard';
import { ListOnlineUsersPerOrganizationIndicators } from 'domain/usecases/dashboard';
import { makeApiUrlOnlineUsersPerOrganizationIndicators } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeListOnlineUsersPerOrganizationIndicators =
  (): ListOnlineUsersPerOrganizationIndicators =>
    new RemoteListOnlineUsersPerOrganizationIndicators(
      makeApiUrlOnlineUsersPerOrganizationIndicators(),
      makeAxiosHttpClient(),
    );
